import React, { useEffect, useState, useRef } from 'react';
import { Button, Switch, Tooltip } from 'antd';
import { CSVLink } from 'react-csv';
import DataTable from 'react-data-table-component';
import 'antd/dist/antd.css';
import { useHistory } from "react-router-dom";
import { ADMIN_GET_ALL_APPROVED_USERS, FING_PAY_KYC_STATUS_CHANGED, POST_INSTANT_REKYC_API, FINO_USER_STATUS_CHANGED, POST_FINO_ADD_FINO_MERCHANT, POST_DMT_NSDL_ADD_UPDATE_NSDLID, POST_DMT_JIO_ADD_UPDATE_NSDLID, POST_DMT_AIRTEL_ADD_UPDATE_AIRTELID, UPDATE_UPI_QR_OUTLET_ID } from './../../../Utils/appConstants';
import { getRequest, postRequest } from './../../../Utils/AppApi';
import { hideCharters, ekoOnboardingStatus, FundRequestValueCSV } from './../../../Utils/Common';
import moment from 'moment';
import { getUTCToLocalDateFormat } from '../../../Utils/function';
import { toast } from 'react-toastify';

const overlay = {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.55)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
};

const modal = {
    width: 420,
    background: '#fff',
    borderRadius: 10,
    padding: 24,
    boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
};

const title = { fontSize: 18, fontWeight: 600, marginBottom: 16 };
const label = { fontSize: 14, fontWeight: 500, color: '#374151' };
const input = {
    width: '100%',
    marginTop: 6,
    padding: '10px 12px',
    borderRadius: 6,
    border: '1px solid #d1d5db',
};
const footer = {
    marginTop: 20,
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 10,
};
const cancelBtn = {
    padding: '8px 14px',
    background: '#f3f4f6',
    border: '1px solid #d1d5db',
    borderRadius: 6,
    cursor: 'pointer',
};
const saveBtn = {
    padding: '8px 16px',
    background: '#2563eb',
    color: '#fff',
    border: 'none',
    borderRadius: 6,
    cursor: 'pointer',
};


function App(props) {

    const history = useHistory();
    const csvLink = useRef()
    const limit = 10;
    const getMode = props.mode ? props.mode : "";
    const startDate = props.startDate ? props.startDate : "";
    const endDate = props.endDate ? props.endDate : "";
    const search = props.search ? props.search : "";
    const accountType = props.accountType ? props.accountType : "";

    const [getData, setData] = useState([]);
    const [getCsvData, setCsvData] = useState([]);
    const [getTotalRecord, setTotalRecord] = useState(0);
    const [isLimit, setLimit] = useState(limit)
    const [page, setPage] = useState(1);

    const FimIdCell = ({ row, updateFimId }) => {
        const existingFimId = row?.finousers?.length > 0 ? row.finousers[0].merchantId : '';

        const [open, setOpen] = useState(false);
        const [fimId, setFimId] = useState(existingFimId);
        const [loading, setLoading] = useState(false);

        const isEdit = Boolean(existingFimId);

        const saveFimId = async () => {
            // ✅ Allow empty ONLY for update
            if (!isEdit && !fimId.trim()) return;

            await updateFimId(
                row.userId,
                fimId.trim() || null   // send null if cleared
            );

            setOpen(false);
        };

        return (
            <>
                <button
                    onClick={() => setOpen(true)}
                    style={{ background: 'none', border: 'none', color: '#2563eb' }}
                >
                    {existingFimId || 'Add'}
                </button>

                {open && (
                    <div style={overlay} onClick={() => setOpen(false)}>
                        <div style={modal} onClick={(e) => e.stopPropagation()}>
                            <h3 style={title}>
                                {isEdit ? 'Update FINO MERCHANT ID' : 'Add FINO MERCHANT ID'}
                            </h3>

                            <input
                                value={fimId}
                                onChange={e => setFimId(e.target.value)}
                                style={input}
                            />

                            <div style={footer}>
                                <button
                                    onClick={() => setOpen(false)}
                                    style={cancelBtn}
                                >
                                    Cancel
                                </button>

                                <button
                                    onClick={saveFimId}
                                    style={saveBtn}
                                >
                                    {isEdit ? 'Update' : 'Add'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    };


    const NSDLIdCell = ({ row, updateFimId }) => {

        const existingNSDLId = row?.nsdloutletId > 0 ? row.nsdloutletId : '';

        const [open, setOpen] = useState(false);
        const [nsdlId, setNsdlId] = useState(existingNSDLId);
        const [loading, setLoading] = useState(false);

        const isEdit = Boolean(existingNSDLId);

        const saveFimId = async () => {
            // ✅ Allow empty ONLY for update
            if (!isEdit && !nsdlId.trim()) return;

            await updateFimId(
                row.userId,
                nsdlId.trim() || null   // send null if cleared
            );

            setOpen(false);
        };

        return (
            <>
                <button
                    onClick={() => setOpen(true)}
                    style={{ background: 'none', border: 'none', color: '#2563eb' }}
                >
                    {existingNSDLId || 'Add'}
                </button>

                {open && (
                    <div style={overlay} onClick={() => setOpen(false)}>
                        <div style={modal} onClick={(e) => e.stopPropagation()}>
                            <h3 style={title}>
                                {isEdit ? 'Update NSDL ID' : 'Add NSDL ID'}
                            </h3>

                            <input
                                value={nsdlId}
                                onChange={e => setNsdlId(e.target.value)}
                                style={input}
                            />

                            <div style={footer}>
                                <button
                                    onClick={() => setOpen(false)}
                                    style={cancelBtn}
                                >
                                    Cancel
                                </button>

                                <button
                                    onClick={saveFimId}
                                    style={saveBtn}
                                >
                                    {isEdit ? 'Update' : 'Add'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    };

    const JIOIdCell = ({ row, updateFimId }) => {

        const existingNSDLId = row?.jioOutletId > 0 ? row.jioOutletId : '';

        const [open, setOpen] = useState(false);
        const [nsdlId, setNsdlId] = useState(existingNSDLId);
        const [loading, setLoading] = useState(false);

        const isEdit = Boolean(existingNSDLId);

        const saveFimId = async () => {
            // ✅ Allow empty ONLY for update
            if (!isEdit && !nsdlId.trim()) return;

            await updateFimId(
                row.userId,
                nsdlId.trim() || null   // send null if cleared
            );

            setOpen(false);
        };

        return (
            <>
                <button
                    onClick={() => setOpen(true)}
                    style={{ background: 'none', border: 'none', color: '#2563eb' }}
                >
                    {existingNSDLId || 'Add'}
                </button>

                {open && (
                    <div style={overlay} onClick={() => setOpen(false)}>
                        <div style={modal} onClick={(e) => e.stopPropagation()}>
                            <h3 style={title}>
                                {isEdit ? 'Update JIO ID' : 'Add JIO ID'}
                            </h3>

                            <input
                                value={nsdlId}
                                onChange={e => setNsdlId(e.target.value)}
                                style={input}
                            />

                            <div style={footer}>
                                <button
                                    onClick={() => setOpen(false)}
                                    style={cancelBtn}
                                >
                                    Cancel
                                </button>

                                <button
                                    onClick={saveFimId}
                                    style={saveBtn}
                                >
                                    {isEdit ? 'Update' : 'Add'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    };


    const AirtelIdCell = ({ row, updateFimId }) => {

        const existingNSDLId = row?.airTel2OutletId > 0 ? row.airTel2OutletId : '';

        const [open, setOpen] = useState(false);
        const [nsdlId, setNsdlId] = useState(existingNSDLId);
        const [loading, setLoading] = useState(false);

        const isEdit = Boolean(existingNSDLId);

        const saveFimId = async () => {
            // ✅ Allow empty ONLY for update
            if (!isEdit && !nsdlId.trim()) return;

            await updateFimId(
                row.userId,
                nsdlId.trim() || null   // send null if cleared
            );

            setOpen(false);
        };

        return (
            <>
                <button
                    onClick={() => setOpen(true)}
                    style={{ background: 'none', border: 'none', color: '#2563eb' }}
                >
                    {existingNSDLId || 'Add'}
                </button>

                {open && (
                    <div style={overlay} onClick={() => setOpen(false)}>
                        <div style={modal} onClick={(e) => e.stopPropagation()}>
                            <h3 style={title}>
                                {isEdit ? 'Update AIRTEL2 ID' : 'Add AIRTEL2 ID'}
                            </h3>

                            <input
                                value={nsdlId}
                                onChange={e => setNsdlId(e.target.value)}
                                style={input}
                            />

                            <div style={footer}>
                                <button
                                    onClick={() => setOpen(false)}
                                    style={cancelBtn}
                                >
                                    Cancel
                                </button>

                                <button
                                    onClick={saveFimId}
                                    style={saveBtn}
                                >
                                    {isEdit ? 'Update' : 'Add'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    };


    const UPIQRIDCell = ({ row, updateFimId }) => {

        const existingNSDLId = row?.upiQrOutletId > 0 ? row.upiQrOutletId : '';

        const [open, setOpen] = useState(false);
        const [upiQrOutletId, setUpiQrOutletId] = useState(existingNSDLId);
        const [loading, setLoading] = useState(false);

        const isEdit = Boolean(existingNSDLId);

        const saveFimId = async () => {
            // ✅ Allow empty ONLY for update
            if (!isEdit && !upiQrOutletId.trim()) return;

            await updateFimId(
                row.userId,
                upiQrOutletId.trim() || null   // send null if cleared
            );

            setOpen(false);
        };

        return (
            <>
                <button
                    onClick={() => setOpen(true)}
                    style={{ background: 'none', border: 'none', color: '#2563eb' }}
                >
                    {existingNSDLId || 'Add'}
                </button>

                {open && (
                    <div style={overlay} onClick={() => setOpen(false)}>
                        <div style={modal} onClick={(e) => e.stopPropagation()}>
                            <h3 style={title}>
                                {isEdit ? 'Update UPI QR  ID' : 'Add UPI QR ID'}
                            </h3>

                            <input
                                value={upiQrOutletId}
                                onChange={e => setUpiQrOutletId(e.target.value)}
                                style={input}
                            />

                            <div style={footer}>
                                <button
                                    onClick={() => setOpen(false)}
                                    style={cancelBtn}
                                >
                                    Cancel
                                </button>

                                <button
                                    onClick={saveFimId}
                                    style={saveBtn}
                                >
                                    {isEdit ? 'Update' : 'Add'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    };

    const columns = [
        {
            name: 'ID Created',
            cell: row => getUTCToLocalDateFormat(row.createdAt),
            width: "120px"
        }, {
            name: 'User Id',
            selector: row => <><Tooltip placement="bottom" title={row.user.username}>{row.user.username}</Tooltip></>,
            sortable: true,
            width: "120px"
        }, {
            name: 'User Type',
            selector: row => <Tooltip placement="bottom" title={row.role.name}>{row.user.isStaff ? "STAFF" : row.role.name}</Tooltip>,
            width: "120px",
        }, {
            name: 'Pan No.',
            selector: row => <Tooltip placement="bottom" title={hideCharters(row.pancardNumber)}>{hideCharters(row.pancardNumber)}</Tooltip>,
            width: "120px"
        }, {
            name: 'Name',
            selector: row => <Tooltip placement="bottom" title={row.user.name}>{row.user.name}</Tooltip>,
            width: "150px"
        }, {
            name: 'Mobile',
            selector: row => hideCharters(row.mobile),
            width: "120px"
        }, {
            name: 'Parent ID',
            selector: row => <><Tooltip placement="bottom" title={row.userParentDetail && row.userParentDetail.username}>{row.userParentDetail && row.userParentDetail.username}</Tooltip></>,
            width: "150px"
        }, {
            name: 'FP Status',
            cell: row => <>{(row.fingusers.length > 0 && row.fingusers[0].merchantBioMetricStatus) ? <div className="text-success">Success</div> : <div className="text-warning">Pending</div>}</>,
            width: "120px"
        }, {
            name: 'FP ID',
            cell: row => <>{row.fingusers.length > 0 ? row.fingusers[0].merchantLoginId : "-"}</>,
            width: "100px"
        }, {
            name: 'FP Date',
            cell: row => row.fingusers.length > 0 ? getUTCToLocalDateFormat(row.fingusers[0].createdAt) : "-",
            width: "120px"
        }, {
            name: 'FP Service',
            cell: row => row.fingusers.length > 0 ? <Switch checked={row.fingusers[0].isCompleted} onChange={(e) => handleFingPayCompleted(e, row.fingusers[0]._id)}></Switch> : "-",
            width: "120px"
        },
        {
            name: 'AP Status',
            cell: row => <>{(row.aadharPayStatus) ? <div className="text-success">Success</div> : <div className="text-warning">Pending</div>}</>,
            width: "120px"
        }, 
         {
            name: 'AP Service',
            cell: row => row.fingusers.length > 0 ? <Switch checked={row.aadharPayEnable} onChange={(e) => handleFingPayCompleted(e, row.aadharPayEnable)}></Switch> : "-",
            width: "120px"
        }, 
        {
            name: 'IP Status',
            cell: row => <>{(row.instantPayBioEkyc) ? <div className="text-success">Success</div> : <div className="text-warning">Pending</div>}</>,
            width: "120px"
        }, {
            name: 'IP ID',
            cell: row => <>{row.outletId}</>,
            width: "100px"
        },
        {
            name: 'NSDL IP ID',
            width: '140px',
            cell: row => <NSDLIdCell row={row} updateFimId={handleNSDLId} />,
        },
        {
            name: 'AIRTEL2 IP ID',
            width: '140px',
            cell: row => <AirtelIdCell row={row} updateFimId={handleAIRTELId} />,
        },
        {
            name: "UPI QR ID",
            width: "140px",
            cell: row => <UPIQRIDCell row={row} updateFimId={handleUPIQRId} />,

        },

        {
            name: 'JIO IP ID',
            width: '140px',
            cell: row => <JIOIdCell row={row} updateFimId={handleJIOId} />,
        },
        {
            name: 'IP Date',
            cell: row => getUTCToLocalDateFormat(row.createdAt),
            width: "120px"
        }, {
            name: 'IP ReKyc',
            cell: row => <Button type="primary" color="default" variant="solid" onClick={() => handleRekyc(row.userId)} >ReKyc</Button>,
            width: "120px"
        }, {
            name: 'E Status',
            cell: row => <>{row.ekoOnboardStatus ? ekoOnboardingStatus(row.ekoOnboardStatus) : '-'}</>,
            width: "120px"
        }, {
            name: 'E ID',
            cell: row => <>{row.ekoOnboardCode ? row.ekoOnboardCode : "-"}</>,
            width: "120px"
        },
        {
            name: 'E Date',
            cell: row => row.ekoOnboardDate ? getUTCToLocalDateFormat(row.ekoOnboardDate) : "-",
            width: "120px"
        },
        {
            name: 'FIS ID',
            cell: row => <>{row.finousers.length > 0 ? row.finousers[0].merchantLoginId : "-"}</>,
            width: "120px"
        },
        {
            name: 'FIM ID',
            width: '140px',
            cell: row => <FimIdCell row={row} updateFimId={handleFinoMerchantId} />,
        },

        {
            name: 'STATUS',
            cell: row => (
                <>
                    {row.finousers.length > 0 ? (
                        row.finousers[0].merchantEkycStatus ? (
                            <div className="text-success">Completed</div>
                        ) : (
                            <div className="text-warning">Pending</div>
                        )
                    ) : (
                        <div>--</div>
                    )}
                </>
            ),
            width: "120px"
        },
        {
            name: 'FINO Service',
            cell: row => {
                if (row.finousers.length === 0 || row.finousers[0].merchantEkycStatus === false) {
                    return "-";
                }
                const finou = row.finousers[0];
                const isCompleted = finou.isCompleted;
                const newStatus = !isCompleted;
                const buttonText = isCompleted ? "Deactivate" : "Activate";
                const buttonProps = isCompleted
                    ? { type: "primary", danger: true }
                    : { type: "primary" };

                return (
                    <Button
                        {...buttonProps}
                        onClick={() => handleFinoStatusChange(newStatus, finou._id)}
                    >
                        {buttonText}
                    </Button>
                );
            },
            width: "120px"
        },

    ]

    const handleRekyc = (userId) => {
        let payload = { userId: userId, mode: 'INSTANTREKYC' }
        postRequest(POST_INSTANT_REKYC_API, payload, history).then((response) => {
            if (response.status === true) {
                toast.success(response.message);
            }
            getDataReports()
        })
    }

    const handleFingPayCompleted = (checked, data) => {
        // setIsCreditUser(checked)
        console.log(`data to ${data}`);
        console.log(`switch to ${checked}`);
        let payload = { id: data, status: checked }
        postRequest(FING_PAY_KYC_STATUS_CHANGED, payload, history).then((response) => {
            if (response.status === true) {
                toast.success(response.message);
            }
            getDataReports()
        })
    };


      const handleAdharPayCompleted = (checked, data) => {
        // setIsCreditUser(checked)
        console.log(`data to ${data}`);
        console.log(`switch to ${checked}`);
        let payload = { id: data, status: checked }
        postRequest(FING_PAY_KYC_STATUS_CHANGED, payload, history).then((response) => {
            if (response.status === true) {
                toast.success(response.message);
            }
            getDataReports()
        })
    };


    const handleFinoStatusChange = (checked, data) => {
        // setIsCreditUser(checked)
        console.log(`data to ${data}`);
        console.log(`switch to ${checked}`);
        let payload = { id: data, status: checked }
        postRequest(FINO_USER_STATUS_CHANGED, payload, history).then((response) => {
            if (response.status === true) {
                toast.success(response.message);
            }
            getDataReports()
        })
    };


    const handleFinoMerchantId = (userID, merchantId) => {
        let payload = { userId: userID, merchantId: merchantId }
        postRequest(POST_FINO_ADD_FINO_MERCHANT, payload, history).then((response) => {
            if (response.status === true) {
                toast.success(response.message);

            } else {
                toast.success(response.message);
            }
            getDataReports()

        })
    };



    const handleAIRTELId = (userID, merchantId) => {
        let payload = { userId: userID, merchantId: merchantId }
        postRequest(POST_DMT_AIRTEL_ADD_UPDATE_AIRTELID, payload, history).then((response) => {
            if (response.status === true) {
                toast.success(response.message);

            } else {
                toast.success(response.message);
            }
            getDataReports()

        })


    };


    const handleUPIQRId = (userID, merchantId) => {
        let payload = { userId: userID, merchantId: merchantId }
        postRequest(UPDATE_UPI_QR_OUTLET_ID, payload, history).then((response) => {
            if (response.status === true) {
                toast.success(response.message);

            } else {
                toast.success(response.message);
            }
            getDataReports()

        })
    };

    const handleNSDLId = (userID, merchantId) => {
        let payload = { userId: userID, merchantId: merchantId }
        postRequest(POST_DMT_NSDL_ADD_UPDATE_NSDLID, payload, history).then((response) => {
            if (response.status === true) {
                toast.success(response.message);

            } else {
                toast.success(response.message);
            }
            getDataReports()

        })
    };



    const handleJIOId = (userID, merchantId) => {
        let payload = { userId: userID, merchantId: merchantId }
        postRequest(POST_DMT_JIO_ADD_UPDATE_NSDLID, payload, history).then((response) => {
            if (response.status === true) {
                toast.success(response.message);

            } else {
                toast.success(response.message);
            }
            getDataReports()

        })
    };


    const objectToQueryString = (obj) => {
        var str = [];
        for (var p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    }

    const params = { page: page, limit: isLimit };

    const getDataReports = (data) => {
        if (data) {
            setLimit(data)
            params.limit = data
        }
        if (startDate && endDate) {
            params.startDate = startDate ? startDate : "";
            params.endDate = endDate ? endDate : "";
        }

        params.roleId = getMode;

        if (search) {
            params.search = search ? search : "";
        }

        if (accountType && accountType !== "all") {
            params.accountType = accountType ? accountType : "";
        }


        const queryString = objectToQueryString(params);
        getRequest(`${ADMIN_GET_ALL_APPROVED_USERS}?${queryString}`, history).then((response) => {
            if (response.success === true) {
                setData(response.data);
                setTotalRecord(response.data.totalDocs);
                setPage(response.data.page);
            } else {
                setData([]);
                setTotalRecord(0);
                setPage(1);
            }
        }).catch(function (error) {
            console.log(error)
            // setLoading(false);
        })
    }

    const getCSVDataList = () => {
        let params = {}
        params.exportsCsv = true;
        if (startDate && endDate) {
            params.startDate = startDate ? startDate : "";
            params.endDate = endDate ? endDate : "";
        }

        params.roleId = getMode;

        if (search) {
            params.search = search ? search : "";
        }

        const queryString = objectToQueryString(params);
        getRequest(`${ADMIN_GET_ALL_APPROVED_USERS}?${queryString}`, history).then((response) => {
            if (response.success === true) {
                let csvdataRecord = [];
                let csvdata = response.data;
                csvdata.map((e) => {
                    return csvdataRecord.push({ "Date": moment(e.createdAt).format("DD/MM/YYYY"), "User Id": e.user.username, "Name": e.user.name, "Mobile": e.mobile, "User Type": e.role.name, "Parent ID": e.userParentDetail && e.userParentDetail.username, "Parent Name": e.userParentDetail && e.userParentDetail.name, "Outlet ID": e.outletId, "Airtel2 ID": e.airTel2OutletId || "-", "NSDL ID": e.nsdloutletId || "-", "JIO ID": e.jioOutletId || "-", "FP ID": e.fingusers.length > 0 ? e.fingusers[0].merchantLoginId : "-", "FP Status": e.fingusers.length > 0 && e.fingusers[0].merchantBioMetricStatus ? "Completed" : "--", "Outlet Name": e.outletName, "KYC Status": FundRequestValueCSV(e.user.KYCStatus), "Reason": e.rejectReason, });
                });
                setCsvData(csvdataRecord);
                setTimeout(() => {
                    csvLink.current.link.click();
                }, 1000);
            } else {
                setCsvData([]);
            }
        }).catch(function (error) {
            console.log(error)
            // setLoading(false);
        })
    }

    const handlePageChange = page => {
        setPage(page);
    };

    useEffect(() => {
        getDataReports();
    }, [page, props.handleSearch]) // eslint-disable-line react-hooks/exhaustive-deps

    // useEffect(() => {
    //     getDataReports();
    //     // setIsDownloadCsv(isDownloadCsv ? true : false);
    // }, []) // eslint-disable-line react-hooks/exhaustive-deps


    return (
        <div>
            <div className="container-fluid pt-2 pb-5">
                <div className="col-md-12">
                    <div className='float-sm-right d-flex mb-1'>
                        <button type="button" className="btn btn-primary mr-3" onClick={() => getCSVDataList()} ><i className="fa fa-file-excel"></i> Export</button>
                        <CSVLink
                            data={getCsvData}
                            filename='E-kyc-verified.csv'
                            className='hidden'
                            ref={csvLink}
                            target='_blank'
                        />
                        {/* <button type="button" className="btn btn-danger">
                            <i className="fa fa-file-pdf"></i> Export to PDF
                        </button> */}
                    </div>
                    <div className="box-body">
                        <DataTable
                            // title={getMode}
                            columns={columns}
                            data={getData.docs}
                            highlightOnHover
                            pagination
                            paginationServer
                            striped
                            paginationTotalRows={getTotalRecord}
                            onChangeRowsPerPage={getDataReports}
                            onChangePage={handlePageChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default App